const CACHE_MANAGEMENET_URL = process.env.API_URL + '/datastore';

const getCache = (context) => {
  return context.$http.get(CACHE_MANAGEMENET_URL);
};

const deleteCache = (context, ids) => {
  return context.$http.delete(CACHE_MANAGEMENET_URL, {params: {ids: ids}});
};

export default {
  getCache,
  deleteCache
};



// WEBPACK FOOTER //
// ./src/api/cacheManagement/cacheManagementHttp.js